import axios from 'axios'
import { ApiConfig } from '../../../config/api'

export const patchResolveAlert = (
  positionAlertDetailId: number,
  quantityToRelease: number,
  externalStorage: boolean,
  destinationPosition: number
) => {
  const url = new URL(
    `${ApiConfig.PositionAlertDetail}/${positionAlertDetailId}/adjust`
  )

  const body = {
    quantityToRelease,
    externalStorage,
    destinationPosition
  }

  return axios.patch(url.toString(), body)
}

export const validatePosition = (
  positionCode: string,
  typePositionId: number
) => {
  const url = new URL(
    `${ApiConfig.PositionAlert}/ValidatePosition/${positionCode}?typePositionId=${typePositionId}`
  )

  return axios.get(url.toString())
}

export const patchPositionAlertId = (positionAlertId: number[]) => {
  const url = new URL(
    `${ApiConfig.PositionAlert}/ResolveAlert/${positionAlertId}`
  )

  return axios.patch(url.toString())
}

export const postPositionAlertId = (positionAlertIds: number[]) => {
  const url = new URL(`${ApiConfig.PositionAlert}/ResolveAlerts`)

  return axios.post(url.toString(), { positionAlertIds })
}

export const getPositionAlertDetails = (
  positionAlertId: number,
  page = 0,
  pageSize = 5
) => {
  const url = new URL(`${ApiConfig.PositionAlert}/Details`)
  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())
  url.searchParams.set('positionAlertId', positionAlertId.toString())
  url.searchParams.set('isResolved', 'false')
  return axios.get(url.toString())
}

export const patchPositionAlertDetailResolveMassive = (
  positionAlertDetailIds: number[]
) => {
  const url = new URL(`${ApiConfig.PositionAlertDetail}/resolvemassive`)

  return axios.patch(url.toString(), {
    positionAlertDetailIds: positionAlertDetailIds
  })
}

export const patchResolvePositionAlertDetail = (
  positionAlertDetailId: number
) => {
  const url = new URL(
    `${ApiConfig.PositionAlertDetail}/${positionAlertDetailId}/resolve`
  )

  return axios.patch(url.toString())
}
